import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ConciergeBookingWidget } from "@/modules/coaching/concierge-booking/components/ConciergeBookingWidget";

// @deprecated Legacy Calendly concierge booking. The native Coach Matching flow
// lives at /embed/coach-matching; this route is kept only as the migration
// fallback (MEM-866). Remove once Calendly is retired ("Out of Calendly").
const conciergeBookingParams = z.object({
  sessionId: z.number(),
  calendlyUrl: z.string(),
  name: z.string().optional(),
  email: z.string(),
  utmSource: z.string(),
  utmMedium: z.string(),
  utmCampaign: z.string(),
});

export const Route = createFileRoute("/embed/concierge-booking")({
  validateSearch: conciergeBookingParams,
  component: ConciergeBookingWidget,
});
